import { jsx } from 'react/jsx-runtime';
import React__default, { useState, useEffect } from 'react';
import { useFabricSocketIo } from '../useFabricSocketIo.js';
import { SocketIOParentRoomContext } from './SocketIOParentRoomContext.js';
import { getRoomPath } from '../utils/getRoomPath.js';

const SocketIOParentRoomProvider = ({ children, room = {
  path: "timeline"
}, enabled = true, allowUnauthenticated, stayConnectedWhenDocumentNotVisible = false }) => {
  const roomPath = getRoomPath(room);
  const { socket, isConnected, error } = useFabricSocketIo({
    roomPath,
    enabled,
    allowUnauthenticated,
    stayConnectedWhenDocumentNotVisible
  });
  const [state, setState] = useState({
    connectedClients: 0
  });
  useEffect(() => {
    const updateCount = (data) => {
      setState((prev) => ({
        ...prev,
        connectedClients: data.count
      }));
    };
    socket.on("CLIENT:COUNT:CHANGED", updateCount);
    return () => {
      socket.off("CLIENT:COUNT:CHANGED", updateCount);
    };
  }, [
    socket
  ]);
  const providedValue = React__default.useMemo(() => {
    return {
      socket,
      isConnected,
      error,
      connectedClients: state.connectedClients
    };
  }, [
    socket,
    error,
    isConnected,
    state.connectedClients
  ]);
  return /* @__PURE__ */ jsx(SocketIOParentRoomContext.Provider, {
    value: providedValue,
    children
  });
};
function withSocketIOParentRoomProvider(Component, options) {
  const connectWhenResourceIdNotProvided = options?.connectWhenResourceIdNotProvided ?? false;
  const WithSocketIOProviderResources = (props) => props.resourceId || connectWhenResourceIdNotProvided ? /* @__PURE__ */ jsx(SocketIOParentRoomProvider, {
    room: props.resourceId ? {
      path: "resources",
      params: {
        resourceId: props.resourceId
      }
    } : void 0,
    children: /* @__PURE__ */ jsx(Component, {
      ...props
    })
  }) : /* @__PURE__ */ jsx(Component, {
    ...props
  });
  return WithSocketIOProviderResources;
}

export { SocketIOParentRoomProvider, withSocketIOParentRoomProvider };
//# sourceMappingURL=SocketIOParentRoomProvider.js.map
